import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import { useGetFacilitySettingValue } from './useGetFacilitySettingValue';

/** @deprecated Use `useScreenerSetting<'enabled' | 'disabled'>('waitlist_enabled', facilityId)` from `src/hooks/screener-settings` instead. Compose the LaunchDarkly flag at the call site. */
export function useIsScreenerLeadWaitlistEnabled(): boolean {
  const { value: waitlistEnabled } =
    useGetFacilitySettingValue('waitlist_enabled');

  const featureFlagEnabled = FeatureFlagService.isEnabled(
    ExacareFeature.CRM_SCREENER_LEAD_WAITLIST
  );

  return featureFlagEnabled && waitlistEnabled === 'enabled';
}
